import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

function PineLabsReturn() {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    history.replace(`/payment${location.search || ""}`);
  }, [history, location.search]);

  return null;
}

export default PineLabsReturn;
